<kodit-table
  [tableConfig]="tableConfig"
  [paginatedData]="paginatedData!"
  [chipItems]="chipItems"
  [isTableLoading]="isLoading"
>
</kodit-table>
